export default {"src":"/_next/static/media/shareIcon.773c9ce7.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};